import { useEffect, useState } from 'react';
import { getWhisper, onWhisperStatus, retryWhisper, type WhisperStatus as WS } from '../lib/whisper';
import { colors } from '../theme';

// Thin status banner — mirrors the native ModelStatus banner. Kicks off the
// model load on mount so transcripts are available by the time the user
// records their first clip (or a few seconds after).
export function WhisperStatus() {
  const [status, setStatus] = useState<WS>({ kind: 'idle' });

  useEffect(() => {
    const unsub = onWhisperStatus(setStatus);
    getWhisper().catch(() => {});
    return unsub;
  }, []);

  if (status.kind === 'idle' || status.kind === 'ready') return null;

  const tone =
    status.kind === 'error' ? colors.danger : status.kind === 'loading' ? colors.accentDim : colors.accent;

  return (
    <div className="ws-banner" style={{ background: tone }}>
      <span>
        {status.kind === 'loading' && status.message}
        {status.kind === 'error' && `Voice model error: ${status.message}`}
      </span>
      {status.kind === 'error' && (
        <button
          onClick={() => {
            retryWhisper();
            getWhisper().catch(() => {});
          }}
        >
          Retry
        </button>
      )}
      <style>{`
        .ws-banner {
          position: absolute;
          top: calc(env(safe-area-inset-top) + 72px);
          left: 12px; right: 12px;
          color: ${colors.bg};
          padding: 8px 12px;
          border-radius: 8px;
          font-size: 12px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 8px;
          z-index: 1000;
        }
        .ws-banner button {
          background: rgba(23,22,28,0.35);
          color: ${colors.bg};
          border: none;
          padding: 4px 10px;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 700;
        }
      `}</style>
    </div>
  );
}
